import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, Overline } from "./Reveal";

const STEPS = [
  "Select Products",
  "Choose Packaging",
  "Customize Your Brand",
  "Product Preparation",
  "Shipment",
];

export default function PrivateLabel() {
  return (
    <section id="private-label" data-testid="private-label-section" className="bg-cream py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <FadeUp>
            <Overline>Private Label & Contract Packaging</Overline>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-navy md:text-5xl">
              Build Your Brand. We’ll Handle the Rest.
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-navy/70">
              Launch or expand your own premium food product line with our
              private-label solutions. RBL EXIM can support customers with
              quality products, customized branding and packaging solutions,
              helping international buyers create products under their own
              brand.
            </p>

            <ol className="mt-10 space-y-0" data-testid="private-label-steps">
              {STEPS.map((step, i) => (
                <li key={step} className="flex items-center gap-5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gold bg-white font-display text-sm font-semibold text-navy">
                    {i + 1}
                  </span>
                  <p className="py-3.5 text-base font-medium text-navy">{step}</p>
                  {i < STEPS.length - 1 && (
                    <span className="absolute" aria-hidden="true" />
                  )}
                </li>
              ))}
            </ol>

            <Link
              to="/#enquire?privateLabel=Yes"
              data-testid="private-label-cta"
              className="group mt-10 inline-flex items-center gap-3 rounded-full bg-navy px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-gold hover:text-navy"
            >
              Discuss Your Private Label Project
              <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </FadeUp>

          <FadeUp delay={0.12}>
            <div className="overflow-hidden rounded-2xl border border-navy/10 shadow-xl shadow-navy/10">
              <img
                src="/assets/brand/private-label.jpg"
                alt="RBL EXIM private label packaging — pouches and jars ready for custom branding"
                loading="lazy"
                className="w-full object-cover transition-transform duration-700 hover:scale-[1.02]"
              />
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
